/**
 * Created by Victor Rojo on 13/6/18.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { I18NService } from "../shared/i18n/i18n.service";

@Pipe({name: 'NotificationReceiverStatus'})
export class NotificationReceiverStatusPipe implements PipeTransform {

  constructor(private i18nService: I18NService){

  }

  transform(value: number): string {
    let res = "";
    switch (value) {
      case -1:
        res = this.i18nService.get("error");
        break;
      case 0:
        res = this.i18nService.get("waiting");
        break;
      case 1:
        res = this.i18nService.get("sent");
        break;
    }
    return res;
  }
}
